export function getRLContentContainer(): Element | undefined {
  const containers = document.getElementsByClassName('RLContentContainer')
  return containers.length > 0 ? containers[0] : undefined
}

export function getWidth(): number {
  return window.innerWidth || document.body.clientWidth
}

export function isXs(): boolean {
  return getWidth() < 576
}

export function isSm(): boolean {
  const width = getWidth()
  return width >= 576 && width < 768
}

export function isMd(): boolean {
  const width = getWidth()
  return width >= 768 && width < 992
}

export function isLg(): boolean {
  const width = getWidth()
  return width >= 992 && width < 1200
}

export function isXl(): boolean {
  return getWidth() >= 1200
}
